


// Vue
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { Mixins } from "vue-mixin-decorator";
import { mapGetters } from "vuex";

// Constants
import Assets from "@/constants/assets.ts";
import Constants from "@/constants/constants.ts";

// Views
import FormView from "@/shared/views/form.view.vue";
import ConvocationInfo from "@/clickbuy/purchase/views/convocation-info.view.vue";
import DownloadView from "@/clickbuy/purchase/views/download-view/index.vue";
import CompanionPartial from "@/clickbuy/purchase/views/filling-in-form/companion-partial/index.vue";

// Components
import Input, {
  InputType,
  InputStyle
} from "@/shared/components/input.component.vue";
import Field from "@/shared/components/field.component.vue";
import FieldSet from "@/shared/components/field-set.component.vue";
import Checkbox, { CheckboxPredefinedStyle } from "@/shared/components/checkbox.component.vue";
import Btn, { BtnPredefinedStyle, BtnColor, BtnWidth } from "@/shared/components/btn.component.vue";
import ItemThumb, { ItemThumbPrefeginedStyle } from "@/shared/components/item-thumb.component.vue";

// Models
import { Purchase, PaymentMethod, PurchaseCompletionStatus } from "@/clickbuy/purchase/models/purchase.model";
import { TypeOfProduct } from "@/manager/product/models/product.model";
import { SaleInfoProductInterface } from "@/clickbuy/purchase/models/sale-info.model";
import { Participant } from "@/manager/convocation/participant.model";
import { Bill } from "@/clickbuy/purchase/models/bill.model";
import { Companion } from "@/clickbuy/purchase/models/companion.model";


// Mixins
import ErrorMixin from "@/shared/mixins/error.mixin";

// Services
import { PurchaseService } from "@/manager/purchase/purchase.service";
import UtilsService from "@/core/services/utils.service";
import ClientService from "@/manager/client/client.service";
// interface MixinInterface extends ErrorMixin {}

@Component({
  components: {
    Btn,
    Checkbox,
    ConvocationInfo,
    CompanionPartial,
    Field,
    FieldSet,
    FormView,
    Input,
    ItemThumb,
    DownloadView
  },
  computed: {
    ...mapGetters({
      getPurchase: "getPurchase"
    })
  }
})
export default class FillingInForm extends Mixins<ErrorMixin>(ErrorMixin) {
  @Prop() private purchaseId!: string;


  private assets = Assets;
  private btnPredefinedStyle = BtnPredefinedStyle;
  private checkboxPredefinedStyle = CheckboxPredefinedStyle;
  private itemThumbPrefeginedStyle = ItemThumbPrefeginedStyle;
  private btnColor = BtnColor;
  private btnWidth = BtnWidth;
  private inputType = InputType;
  private inputStyle = InputStyle;
  private purchaseService = PurchaseService;
  private productSelected: SaleInfoProductInterface = {};
  private nifMask = "";
  private nifMaskBill = "";
  private getPurchase!: any;
  private purchaseLoaded = false;
  private dataProtection = false;
  private dataProtectionUrl = "https://www.levelupdesarrollo.com/politica-de-privacidad-level-up/";
  private purchase = new Purchase();
  private billDataCollapsed = true;
  private disableSendFormBtn = false;
  private billNif = "";
  public error: any = {
    client: {
      user: {
        email: "",
        firstName: "",
        lastName: "",
        profile: {
          nif: "",
          phone: "",
          town: "",
          address: "",
          postalCode: ""
        }
      }
    },
    purchaseLines: [{
      companionPurchaseLine: []
    }],
    nonFieldErrors: "",
    dataProtection: ""
  };
  private literals = {
    header: {
      title: "Gracias por tu compra",
      subtitle: "Revisa tus datos personales y modifica aquellos que desees:"
    },
    billing: {
      title: "Facturación",
      subtitle: "Este es el resumen de tu compra:"
    },
    downloadBill: "Descargar factura",
    downloadPurchaseDocument: "Descargar albarán"
  };
  private messageError = "";

  @Watch("error.nonFieldErrors")
  private watchNonFieldErrors(newVal: string, oldVal: string) {
    setTimeout(() => {
      if (newVal !== "") {
        this.error.nonFieldErrors = "";
      }
    }, Constants.notificationMessageTimeToAppear);
  }

  @Watch("purchase.client.user.profile.nif")
  private watchNif(newVal: string, oldVal: string) {
    this.nifMask = UtilsService.setNifMask(newVal, this.nifMask);
  }

  @Watch("billNif")
  private watchNifBill(newVal: string, oldVal: string) {
    (this.purchase.bill as any).nif = newVal;
    this.nifMaskBill = UtilsService.setNifMask(newVal, this.nifMaskBill);
  }


  private created() {
    this.fetchPurchase(() => {
      this.purchase = this.getPurchase(this.purchaseId);
      this.purchaseLoaded = true;
      if (this.showFormView) {
        if (!this.purchase.bill) {
          this.purchase.bill = new Bill();
        }
        this.fetchFiscalData();
        this.initializeCompanions();
      }
    });
  }

  private mounted() {
    this.setScrollParentNode();
  }

  get billingDataSubtitle() {
    return this.billingDataDisabled
        ? "No se pueden modificar los Datos de Facturación debido a que el plazo de modificación ha expirado o el número de modificaciones ha sido excedido"
        : "Si tus datos de facturación son diferentes a los personales, por favor rellénalos aquí.";

  }

  get isConference() {
    try {
      return this.purchase.purchaseLines[0].typeOfProduct === TypeOfProduct.Conference;
    } catch {
      return false;
    }
  }

  get billingDataDisabled() {
    if (!this.purchase.created || !this.isConference) {
      return false;
    }
    const year = new Date().getFullYear();
    const trimester1: Array<Date> = [new Date(`01/01/${year}`), new Date(`03/31/${year}`)];
    const trimester2: Array<Date> = [new Date(`04/01/${year}`), new Date(`06/30/${year}`)];
    const trimester3: Array<Date> = [new Date(`07/01/${year}`), new Date(`09/30/${year}`)];
    const trimester4: Array<Date> = [new Date(`10/01/${year}`), new Date(`12/31/${year}`)];

    const current: Array<Array<Date>> = [trimester1, trimester2, trimester3, trimester4].filter((e) => {
      return this.isBetween(new Date(), e[0], e[1]);
    });
    return !this.isBetween(new Date(this.purchase.created), current[0][1], current[0][1]);
  }

  private isBetween(date: Date, min: Date, max: Date): boolean {
    return date.getTime() >= min.getTime() && date.getTime() <= max.getTime();
  };

  get purchaseHasBillDocument() {
    let hasBill = true;
    if (
        (
            this.purchase.bill === undefined ||
            this.purchase.bill === null
        ) ||
        (
            this.purchase.bill &&
            (
                this.purchase.bill.id === undefined ||
                this.purchase.bill.id === ""
            )
        )
    ) {
      hasBill = false;
    }
    return hasBill;
  }

  get downloadBtnLabel() {
    let billText = "";
    if (this.purchaseHasBillDocument) {
      billText = "factura y ";
    }
    return `Puedes descargar tu ${billText}albarán a continuación:`;
  }

  get showDownloadView() {
    return this.purchaseLoaded && this.purchase.completionStatus === PurchaseCompletionStatus.Finished;
  }

  get showFormView() {
    return this.purchaseLoaded && (
        this.purchase.completionStatus === PurchaseCompletionStatus.Pending ||
        this.purchase.completionStatus === PurchaseCompletionStatus.Editable
    );
  }

  get hasCompanions() {
    return this.purchase.purchaseLines[0].amount > 1;
  }

  get formComplete() {
    return true;
  }

  get hasServerError() {
    return this.messageError !== "";
  }

  get productInfo() {
    return `Curso intensivo "${this.purchase.purchaseLines[0].productName}"`;
  }

  get purchaseLineTotalPrice() {
    return `${this.purchase.purchaseLines[0].totalPrice}€`;
  }

  get paymentMethod() {
    let paymentMethodName = "";
    if (PaymentMethod.Cash === this.purchase.paymentMethod) {
      paymentMethodName = "Efectivo";
    } else if (PaymentMethod.Card === this.purchase.paymentMethod) {
      paymentMethodName = "Tarjeta";
    }
    return paymentMethodName;
  }


  private initializeCompanions() {
    const amount = this.purchase.purchaseLines[0].amount - 1;
    const companionPurchaseLine = this.purchase.purchaseLines[0].companionPurchaseLine;
    let i = 0;

    if (companionPurchaseLine) {
      for (i; i < amount; i++) {
        if (companionPurchaseLine[i] === undefined) {
          const companion = new Companion();
          companion.convocationTarget = this.purchase.purchaseLines[0].convocationTarget;
          companionPurchaseLine.push(companion);
        }
        const client = {
          client: {
            user: {
              firstName: "",
              email: "",
              profile: {
                phone: ""
              }
            }
          }
        };
        this.error.purchaseLines[0].companionPurchaseLine.push(client);
      }
    }
    this.purchase.purchaseLines[0].companionPurchaseLine = companionPurchaseLine;
  }

  private setScrollParentNode() {
    this.parentNode = document.getElementsByClassName("form-view__content")[0];
  }

  private fetchPurchase(callback = () => {
    const doNothing = 1;
  }) {
    this.$store.dispatch("fetchPurchase", { id: this.purchaseId })
        .then((res: any) => {
          callback();
        });
  }

  private setPurchaseFormError(err: any) {
    const serverError = err.response.data;
    this.error = { ...this.error, ...serverError };

    this.messageError = "Ha ocurrido un error";
    const nonFieldErrors = this.error.nonFieldErrors[0];
    if (nonFieldErrors) {
      this.messageError = nonFieldErrors;
    }
    setTimeout(() => {
      this.messageError = "";
    }, Constants.notificationMessageTimeToAppear);
  }

  private fiscalDataSuccess(res: any) {
    this.fillBillData(res.data);
  }

  private fiscalDataError(err: any) {
    if (err.response.status === 404) {
      this.fillBillData(this.purchase);
    }
  }

  private fetchFiscalData() {
    ClientService.getFiscalData((this.purchase.client as any).user.id)
        .then(this.fiscalDataSuccess, this.fiscalDataError);
  }

  private fillBillData(data: any) {
    if (data.user === (this.purchase.client as any).user.id) {
      this.fillBillDataWithFiscalData(data);
    } else {
      this.fillBillDataWithClientData(data);
    }
  }

  private fillBillDataWithClientData(purchase: any = new Purchase()) {
    const firstName = purchase.client.user.firstName;
    const lastName = purchase.client.user.lastName;
    const secondLastName = purchase.client.user.secondLastName;
    let completeName = "";
    if (firstName || lastName || secondLastName) {
      completeName = `${firstName} ${lastName} ${secondLastName}`;
    }
    (this.purchase as any).bill.name = completeName;
    (this.purchase as any).bill.email = purchase.client.user.email;
    (this.purchase as any).bill.nif = purchase.client.user.profile.nif;
    this.billNif = (this.purchase as any).bill.nif;
    (this.purchase as any).bill.address = purchase.client.user.profile.address;
    (this.purchase as any).bill.phone = purchase.client.user.profile.phone;
    (this.purchase as any).bill.postalCode = purchase.client.user.profile.postalCode;
    (this.purchase as any).bill.town = purchase.client.user.profile.town;
  }

  private fillBillDataWithFiscalData(data: any) {
    const completeName = `${data.firstName} ${data.lastName}`;
    (this.purchase as any).bill.name = completeName;
    (this.purchase as any).bill.email = data.email;
    (this.purchase as any).bill.nif = data.nif;
    this.billNif = (this.purchase as any).bill.nif;
    (this.purchase as any).bill.address = data.address;
    (this.purchase as any).bill.phone = data.phone;
    (this.purchase as any).bill.postalCode = data.postalCode;
    (this.purchase as any).bill.town = data.town;
  }

  private checkMandatoryFields() {
    let result = true;
    if (!this.dataProtection) {
      this.error.dataProtection = "error";
      result = false;
    }
    if ((this.purchase.client.user as any).firstName === "") {
      this.error.client.user.firstName = "Campo vacío";
      result = false;
    }
    if ((this.purchase.client.user as any).lastName === "") {
      this.error.client.user.lastName = "Campo vacío";
      result = false;
    }
    if ((this.purchase.client.user as any).email === "") {
      this.error.client.user.email = "Campo vacío";
      result = false;
    }
    const nif = (this.purchase.client.user as any).profile.nif;
    if (!nif || nif === "") {
      this.error.client.user.profile.nif = "Campo vacío";
      result = false;
    }
    const town = (this.purchase.client.user as any).profile.town;
    if (!town || town === "") {
      this.error.client.user.profile.town = "Campo vacío";
      result = false;
    }
    const phone = (this.purchase.client.user as any).profile.phone;
    if (!phone || phone === "") {
      this.error.client.user.profile.phone = "Campo vacío";
      result = false;
    }
    const address = (this.purchase.client.user as any).profile.address;
    if (!address || address === "") {
      this.error.client.user.profile.address = "Campo vacío";
      result = false;
    }
    const postalCode = (this.purchase.client.user as any).profile.postalCode;
    if (!postalCode || postalCode === "") {
      this.error.client.user.profile.postalCode = "Campo vacío";
      result = false;
    }

    const numberOfCompanions = this.purchase.purchaseLines[0].amount - 1;
    for (let i = 0; i < numberOfCompanions; i++) {
      const ref = "asistente" + i;
      const companionPartialRef = this.$refs[ref];
      const component = (companionPartialRef as CompanionPartial[])[0];
      const companionValidation = component.checkMandatoryFields();
      if (!companionValidation) {
        result = false;
      }
    }

    return result;
  }

  private isReadOnly(value: any) {
    if (!value) {
      value = "";
    }
    const val = String(value);
    return val !== "";
  }

  private sendForm() {
    if (this.checkMandatoryFields()) {

      const purchase = Object.assign({}, this.purchase);

      purchase.completionStatus = PurchaseCompletionStatus.Finished;
      purchase.billFiscalData = this.billDataCollapsed;
      if (this.billDataCollapsed) {
        delete purchase.bill;
      }
      this.disableSendFormBtn = true;
      this.$store.dispatch("updatePurchase", { ...purchase })
          .then(
              (res) => {
                this.purchase = this.getPurchase(this.purchaseId);
                if (this.purchase.completionStatus === PurchaseCompletionStatus.Pending) {
                  this.purchase.bill = new Bill();
                  this.disableSendFormBtn = false;
                }
              },
              (err) => {
                this.setPurchaseFormError(err);
                this.disableSendFormBtn = false;
              }
          );

    }
  }
}

